"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.find-index");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileDelivery = require("@/mixins/last-mile-delivery/last-mile-delivery");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var defaultRouteForm = {
  locked: false,
  startTime: null,
  convertedStartTime: null,
  waitingTime: null,
  handlingTime: null
};

var LMDTruckSummaryModalComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDTruckSummaryModalComponent, _Mixins);

  var _super = _createSuper(LMDTruckSummaryModalComponent);

  function LMDTruckSummaryModalComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDTruckSummaryModalComponent);
    _this = _super.apply(this, arguments);
    _this.routeForm = _this.helper.cloneDeep(defaultRouteForm);
    _this.visibility = false;
    _this.deletedOrders = [];
    return _this;
  }

  (0, _createClass2.default)(LMDTruckSummaryModalComponent, [{
    key: "onDetailsChanges",
    value: function onDetailsChanges(newVal, oldVal) {
      if (newVal) {
        this.deletedOrders = [];
        this.routeForm = {
          locked: newVal['locked'],
          startTime: newVal['startTime'],
          convertedStartTime: this.helper.convertTimezone(newVal['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:ss'),
          waitingTime: newVal['waitingTime'] / 60,
          handlingTime: newVal['handlingTime'] / 60
        };
      }
    }
  }, {
    key: "onVisibilityChanges",
    value: function onVisibilityChanges(newVal) {
      this.visibility = newVal;
    }
    /*getDisabledDates(date) {
      const startDate = moment(this.$planDate).subtract(1, 'days').format('YYYY-MM-DD 23:59:59');
      const endDate = moment(this.$planDate).add(1, 'days').format('YYYY-MM-DD 23:59:59');
      return !moment(date).isBetween(startDate, endDate, 'days', '[]');
    }*/

  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.$emit('onDialogClose');
    }
  }, {
    key: "updateDetails",
    value: function updateDetails() {
      if (this.checkFormValidation(this.routeForm)) {
        // const newDate: Date = new Date(this.routeForm['startTime']);
        // convert Date to String
        if (this.routeForm['convertedStartTime'] instanceof Date) {
          var dateObj = this.routeForm['convertedStartTime'];
          this.routeForm['convertedStartTime'] = dateObj.getFullYear() + '-' + this.helper.pad(dateObj.getMonth() + 1) + '-' + this.helper.pad(dateObj.getDate()) + ' ' + this.helper.pad(dateObj.getHours()) + ':' + this.helper.pad(dateObj.getMinutes()) + ':00';
        }

        var waitingTime = Number(this.routeForm['waitingTime']) * 60;
        var handlingTime = Number(this.routeForm['handlingTime']) * 60;
        this.$emit('onUpdateRouteDetails', {
          index: this.routeIndex,
          routeForm: {
            locked: this.routeForm['locked'],
            // 'startTime': `${this.$planDate} ${this.helper.pad(newDate.getHours())}:${this.helper.pad(newDate.getMinutes())}:00`,
            startTime: this.routeForm['startTime'],
            convertedStartTime: this.helper.revertTimezone(this.routeForm['convertedStartTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
            waitingTime: waitingTime,
            handlingTime: handlingTime,
            processingTime: waitingTime + handlingTime
          }
        });
        this.onDialogClose();
      } else {
        var message = {
          title: this.$i18n.t('planning.messages.invalidUpdateRouteDetails'),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      }
    }
  }, {
    key: "checkFormValidation",
    value: function checkFormValidation(form) {
      return !this.helper.isUndefined(form['startTime']) && !this.helper.isUndefined(form['convertedStartTime']) // !this.helper.isUndefined(form['waitingTime']) &&
      // !this.helper.isUndefined(form['handlingTime'])
      ;
    }
  }, {
    key: "removeOrders",
    value: function () {
      var _removeOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var truckIndex, isAllRoutesUnassigned, isOneOfWaypointCompleted;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$anyChanges = true;
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (truck) {
                  return truck['truckId'] === _this2.$selectedTruck;
                });
                isAllRoutesUnassigned = this.helper.every(this.$plan.trucks[truckIndex].routes, function (route) {
                  return route.status === 'unassigned';
                });
                isOneOfWaypointCompleted = this.helper.some(this.deletedOrders, function (orderId) {
                  var waypoints = _this2.getOrderField(orderId, 'waypoints');

                  return !!waypoints.length ? _this2.helper.some(waypoints, function (i) {
                    return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
                  }) : false;
                });

                if (!isAllRoutesUnassigned) {
                  _context.next = 14;
                  break;
                }

                if (!(this.$plan.orders.length === this.deletedOrders.length)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return this.removeAllOrders();

              case 8:
                _context.next = 12;
                break;

              case 10:
                _context.next = 12;
                return this.removeSomeOrders(truckIndex);

              case 12:
                _context.next = 26;
                break;

              case 14:
                if (!(this.routeDetails['status'] === 'unassigned')) {
                  _context.next = 19;
                  break;
                }

                _context.next = 17;
                return this.removeSomeOrders(truckIndex);

              case 17:
                _context.next = 26;
                break;

              case 19:
                if (!isOneOfWaypointCompleted) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return this.removeSomeCompletedOrders(truckIndex);

              case 22:
                _context.next = 26;
                break;

              case 24:
                _context.next = 26;
                return this.removeSomeAssignedOrders(truckIndex);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function removeOrders() {
        return _removeOrders.apply(this, arguments);
      }

      return removeOrders;
    }()
    /*async removeAllAssignedOrders() {
      const orderShipRefs = this.getShipRefsFromOrderId(this.deletedOrders);
      const payload = [];
      this.helper.forEach(orderShipRefs, order => {
        payload.push({
          shipref: order
        });
      });
         if (payload.length > 0) {
        const cancelDriverAssignmentResponse = await this.cancelDriverAssignment(payload);
        const isCancelSuccessful = cancelDriverAssignmentResponse['isSuccess'];
        const error = cancelDriverAssignmentResponse['error'];
           if (isCancelSuccessful) {
          const message: ElNotificationOptions = {
            title: this.$i18n.t('planning.messages.cancelOrdersAssignmentSuccess'),
            duration: 5000
          } as ElNotificationOptions;
             if (isCancelSuccessful) {
            Notification.success(message);
            this.deletePlan();
          } else {
            message['message'] = `${this.$i18n.t('planning.messages.cancelOrdersAssignmentFailed')} ${this.$i18n.t('planning.messages.dueTo')} ${error}` as string;
            Notification.error(message);
          }
        }
      }
    }*/

  }, {
    key: "removeSomeAssignedOrders",
    value: function () {
      var _removeSomeAssignedOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(truckIndex) {
        var orderShipRefs, payload, bool;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                orderShipRefs = this.getShipRefsFromOrderId(this.deletedOrders);
                payload = [];
                orderShipRefs.forEach(function (order) {
                  payload.push({
                    shipref: order
                  });
                });
                _context2.next = 5;
                return this.removeSomeOrders(truckIndex, 'assigned');

              case 5:
                bool = _context2.sent;

                if (bool) {
                  this.$toBeUnassignedOrderIds = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.$toBeUnassignedOrderIds), payload), 'shipref'); // Insert log

                  this.insertLogs('unassign orders from driver', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                    truckId: this.$selectedTruck,
                    truckIndex: truckIndex,
                    deletedOrders: this.deletedOrders,
                    orderShipRefs: orderShipRefs,
                    toBeUnassignedOrderIds: this.$toBeUnassignedOrderIds,
                    user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS
                  });
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeSomeAssignedOrders(_x) {
        return _removeSomeAssignedOrders.apply(this, arguments);
      }

      return removeSomeAssignedOrders;
    }()
  }, {
    key: "removeSomeCompletedOrders",
    value: function () {
      var _removeSomeCompletedOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(truckIndex) {
        var _this3 = this;

        var orderShipRefs, payload, fRouteByDelOrders, fRouteByPlanId, planId, truckLength, bool1, bool2, bool3, res, bufferPlan;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isManualAssignLoading = true;
                orderShipRefs = this.getShipRefsFromOrderId(this.deletedOrders);
                payload = [];
                orderShipRefs.forEach(function (order) {
                  payload.push({
                    shipref: order
                  });
                });

                if (!(this.deletedOrders.length === 0)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", false);

              case 6:
                fRouteByDelOrders = this.routes.filter(function (r) {
                  return _this3.helper.intersection(r['orderId'], _this3.deletedOrders).length > 0;
                });
                fRouteByPlanId = [];
                planId = null;
                truckLength = this.$plan.trucks.length;
                bool1 = false;
                bool2 = false;
                bool3 = false;

                if (fRouteByDelOrders.length > 0) {
                  planId = fRouteByDelOrders[0]['planId'];
                  fRouteByPlanId = this.routes.filter(function (r) {
                    return r['planId'] === planId;
                  });
                }

                _context3.next = 16;
                return this.reCalculateOfDeletedCompletedRoutes({
                  routes: this.helper.cloneDeep(this.routes),
                  deletedOrders: this.deletedOrders
                });

              case 16:
                res = _context3.sent;

                if (!this.helper.isUndefined(res)) {
                  _context3.next = 19;
                  break;
                }

                return _context3.abrupt("return");

              case 19:
                // this.$emit('onFailedOrders', res);
                // alert('REMOVE COMPLETED ORDERS');
                this.updateCurrentTruck(res);
                bufferPlan = this.helper.cloneDeep(this.$plan); // Delete all of the routes corresponding to that planId

                if (fRouteByDelOrders.length === fRouteByPlanId.length) {
                  bufferPlan.planId = bufferPlan.planId.filter(function (pId) {
                    return pId !== planId;
                  }) || []; // If there are multiple planId, the filter out the deleted order planId

                  if (truckLength === bufferPlan.trucks.length) {
                    bufferPlan.trucks[truckIndex].planId = bufferPlan.trucks[truckIndex].planId.filter(function (pId) {
                      return pId !== planId;
                    }) || [];
                    bufferPlan.trucks[truckIndex].orderId = bufferPlan.trucks[truckIndex].orderId.filter(function (oId) {
                      return !_this3.helper.includes(_this3.deletedOrders, oId);
                    });
                    bool1 = true;
                  } else {
                    // Only single planId, no need to filter out planId. Have been done in updateCurrentTruck
                    this.$emit('onResetPlanId');
                    bool2 = true;
                  }
                } else {
                  // Delete one of the route in the same planId
                  bufferPlan.trucks[truckIndex].orderId = bufferPlan.trucks[truckIndex].orderId.filter(function (oId) {
                    return !_this3.helper.includes(_this3.deletedOrders, oId);
                  });
                  bool3 = true;
                }

                if (!this.helper.isUndefined(bufferPlan.orderId)) {
                  bufferPlan.orderId = bufferPlan.orderId.filter(function (oId) {
                    return !_this3.helper.includes(_this3.deletedOrders, oId);
                  });
                }

                bufferPlan.orders = bufferPlan.orders.filter(function (order) {
                  return !_this3.helper.includes(_this3.deletedOrders, order.id);
                });
                this.$setPlan({
                  plan: bufferPlan
                });
                _context3.next = 27;
                return this.refreshOrderTable();

              case 27:
                this.$emit('onUpdateModalVisibility', false); // Insert log

                this.insertLogs('delete some completed orders', {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                  truck: bufferPlan.trucks[truckIndex],
                  truckId: this.$selectedTruck,
                  truckIndex: truckIndex,
                  deletedOrders: this.deletedOrders,
                  truckLength: truckLength,
                  bufferTruckLength: bufferPlan.trucks.length,
                  fRouteByDelOrders: fRouteByDelOrders,
                  fRouteByPlanId: fRouteByPlanId,
                  bool1: bool1,
                  bool2: bool2,
                  bool3: bool3,
                  user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS
                });
                this.isManualAssignLoading = false;

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeSomeCompletedOrders(_x2) {
        return _removeSomeCompletedOrders.apply(this, arguments);
      }

      return removeSomeCompletedOrders;
    }()
  }, {
    key: "removeAllOrders",
    value: function () {
      var _removeAllOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Insert log
                this.insertLogs('delete all orders', {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                  truckId: this.$selectedTruck,
                  includedOrders: this.$includedOrders,
                  deletedOrders: this.deletedOrders,
                  user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS
                });
                this.$includedOrders = [].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(this.deletedOrders));
                this.deletedOrders = [];
                this.$excludedOrders = [];
                this.$emit('onUpdateModalVisibility', false);
                this.$emit('onResetPlanId');
                this.$setPlan({
                  isReset: true
                });
                _context4.next = 9;
                return this.$getUnassignedOrders();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function removeAllOrders() {
        return _removeAllOrders.apply(this, arguments);
      }

      return removeAllOrders;
    }()
    /**
     * Assume the deletion of orders happen within the same plan id
     * */

    /*async removeSomeOrders(truckIndex: number, routeStatus?: string) {
      if (this.deletedOrders.length === 0) {
        return false;
      }
         const bufferPlan = this.helper.cloneDeep(this.$plan);
      const truckObj = bufferPlan.trucks[truckIndex];
      const delRoutesWithRespectToOrderId = truckObj.routes.filter(route => this.helper.intersection(route.orderId, this.deletedOrders).length > 0);
      const planId = delRoutesWithRespectToOrderId[0]['planId'];
         const otherRoutes = truckObj['routes'].filter(route => route.planId !== planId);
      const orderIds = this.helper.uniq(
        this.helper.flatten(
          bufferPlan.trucks[truckIndex].routes
            .filter(route => route.planId === planId)
            .map(route => route.orderId)
        )
      ).filter(oId => !this.helper.includes(this.deletedOrders, oId));
      const index = this.helper.findIndex(truckObj.routes, route => route.planId === planId);
         if (index === -1) {
        return false;
      }
         // Delete a whole particular truck obj
      if (otherRoutes.length === 0 && orderIds.length === 0) {
        bufferPlan.orders = bufferPlan.orders.filter(order => !this.helper.includes(this.deletedOrders, order.id)) || [];
        bufferPlan.planId = bufferPlan.planId.filter(pId => pId !== planId) || [];
        bufferPlan.trucks = bufferPlan.trucks.filter(truck => truck.truckId !== truckObj.truckId) || [];
        this.$setPlan({ 'plan': bufferPlan });
           await this.refreshOrderTable();
        this.$emit('onUpdateModalVisibility', false);
           this.logger.info('Delete the whole truck obj', { bufferPlan });
        return true;
      }
         // Delete for the rest of the plan id routes
      if (otherRoutes.length !== 0 && orderIds.length === 0) {
        bufferPlan.orders = bufferPlan.orders.filter(order => !this.helper.includes(this.deletedOrders, order.id)) || [];
        bufferPlan.planId = bufferPlan.planId.filter(pId => pId !== planId) || [];
        bufferPlan.trucks[truckIndex].orderId = bufferPlan.trucks[truckIndex].orderId.filter(oId => !this.helper.includes(this.deletedOrders, oId)) || [];
        bufferPlan.trucks[truckIndex].planId = bufferPlan.trucks[truckIndex].planId.filter(pId => pId !== planId) || [];
        bufferPlan.trucks[truckIndex].routes = bufferPlan.trucks[truckIndex].routes.filter(route => route.planId !== planId) || [];
        this.$setPlan({ 'plan': bufferPlan });
           await this.refreshOrderTable();
        this.$emit('onUpdateModalVisibility', false);
           this.logger.info('Delete all of the routes with the same planId', bufferPlan);
        return true;
      }
         // Partially delete the plan id routes
      this.logger.info('Delete some of the routes with the same planId');
         const res = await this.manualAssign({
        orders: bufferPlan.orders.filter(order => this.helper.includes(orderIds, order.id)), // assume there is no invalid orders
        startTime: truckObj.routes[index].startTime,
        truck: this.currTruck,
        planIds: [{ [planId]: orderIds }]
      });
         const vehicles = this.helper.get(res, 'vehicles', null);
      // const invalidReasons = this.helper.get(res, 'invalidReasons', []);
      // const invalidOrderIds = this.helper.flatten(invalidReasons.map(item => item['orderId']));
         if (!(!this.helper.isUndefined(res) && vehicles && vehicles.routes && vehicles.routes.length > 0)) {
        this.$emit('onUpdateModalVisibility', false);
        const message: ElNotificationOptions = {
          title: this.$i18n.t('planning.messages.noSolutionFound'),
          duration: 5000
        } as ElNotificationOptions;
        Notification.error(message);
           return false;
      }
         if (vehicles && !this.helper.isUndefined(routeStatus)) {
        this.helper.forEach(vehicles['routes'], route => route['status'] = routeStatus);
      }
         bufferPlan.orders = bufferPlan.orders.filter(order => !this.helper.includes(this.deletedOrders, order.id));
      bufferPlan.trucks[truckIndex].orderId = bufferPlan.trucks[truckIndex].orderId.filter(oId => !this.helper.includes(this.deletedOrders, oId));
      otherRoutes.splice(index, 0, ...vehicles['routes']);
      bufferPlan.trucks[truckIndex].routes = otherRoutes;
      this.$setPlan({ 'plan': bufferPlan });
         await this.refreshOrderTable();
      this.$emit('onUpdateModalVisibility', false);
         return true;
    }*/

    /**
     * Assume the deletion of orders happen within the same plan id
     * Instead of using manual assign, call calculate api
     * */

  }, {
    key: "removeSomeOrders",
    value: function () {
      var _removeSomeOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(truckIndex, routeStatus) {
        var _this4 = this;

        var fRouteByDelOrders, fRouteByPlanId, planId, truckLength, bool1, bool2, bool3, calculateEta, bufferPlan, title;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.deletedOrders.length === 0)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", false);

              case 2:
                fRouteByDelOrders = this.routes.filter(function (r) {
                  return _this4.helper.intersection(r['orderId'], _this4.deletedOrders).length > 0;
                });
                fRouteByPlanId = [];
                planId = null;
                truckLength = this.$plan.trucks.length;
                bool1 = false;
                bool2 = false;
                bool3 = false;

                if (fRouteByDelOrders.length > 0) {
                  planId = fRouteByDelOrders[0]['planId'];
                  fRouteByPlanId = this.routes.filter(function (r) {
                    return r['planId'] === planId;
                  });
                }

                _context5.next = 12;
                return this.calculateETA({
                  routes: this.helper.cloneDeep(this.routes),
                  startTime: this.routes[0]['startTime'],
                  index: 0,
                  deletedOrders: this.deletedOrders
                });

              case 12:
                calculateEta = _context5.sent;

                if (!calculateEta) {
                  _context5.next = 26;
                  break;
                }

                this.updateCurrentTruck(calculateEta);
                bufferPlan = this.helper.cloneDeep(this.$plan); // Delete all of the routes corresponding to that planId

                if (fRouteByDelOrders.length === fRouteByPlanId.length) {
                  bufferPlan.planId = bufferPlan.planId.filter(function (pId) {
                    return pId !== planId;
                  }) || []; // If there are multiple planId, the filter out the deleted order planId

                  if (truckLength === bufferPlan.trucks.length) {
                    bufferPlan.trucks[truckIndex].planId = bufferPlan.trucks[truckIndex].planId.filter(function (pId) {
                      return pId !== planId;
                    }) || [];
                    bufferPlan.trucks[truckIndex].orderId = bufferPlan.trucks[truckIndex].orderId.filter(function (oId) {
                      return !_this4.helper.includes(_this4.deletedOrders, oId);
                    });
                    bool1 = true;
                  } else {
                    // Only single planId, no need to filter out planId. Have been done in updateCurrentTruck
                    this.$emit('onResetPlanId');
                    bool2 = true;
                  }
                } else {
                  // Delete one of the route in the same planId
                  bufferPlan.trucks[truckIndex].orderId = bufferPlan.trucks[truckIndex].orderId.filter(function (oId) {
                    return !_this4.helper.includes(_this4.deletedOrders, oId);
                  });
                  bool3 = true;
                }

                if (!this.helper.isUndefined(bufferPlan.orderId)) {
                  bufferPlan.orderId = bufferPlan.orderId.filter(function (oId) {
                    return !_this4.helper.includes(_this4.deletedOrders, oId);
                  });
                }

                bufferPlan.orders = bufferPlan.orders.filter(function (order) {
                  return !_this4.helper.includes(_this4.deletedOrders, order.id);
                });
                this.$setPlan({
                  plan: bufferPlan
                });
                _context5.next = 22;
                return this.refreshOrderTable();

              case 22:
                this.$emit('onUpdateModalVisibility', false); // Insert log

                title = this.helper.isUndefined(routeStatus) ? 'delete some orders' : 'delete some assigned orders';
                this.insertLogs(title, {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                  routeStatus: routeStatus,
                  truck: bufferPlan.trucks[truckIndex],
                  truckId: this.$selectedTruck,
                  truckIndex: truckIndex,
                  deletedOrders: this.deletedOrders,
                  truckLength: truckLength,
                  bufferTruckLength: bufferPlan.trucks.length,
                  fRouteByDelOrders: fRouteByDelOrders,
                  fRouteByPlanId: fRouteByPlanId,
                  bool1: bool1,
                  bool2: bool2,
                  bool3: bool3,
                  user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS
                });
                return _context5.abrupt("return", true);

              case 26:
                return _context5.abrupt("return", false);

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeSomeOrders(_x3, _x4) {
        return _removeSomeOrders.apply(this, arguments);
      }

      return removeSomeOrders;
    }()
  }, {
    key: "refreshOrderTable",
    value: function () {
      var _refreshOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this5 = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.$excludedOrders = this.$excludedOrders.filter(function (orderId) {
                  return !_this5.helper.includes(_this5.deletedOrders, orderId);
                });
                this.$includedOrders = [].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(this.deletedOrders));
                _context6.next = 4;
                return this.$getUnassignedOrders();

              case 4:
                this.deletedOrders = [];

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function refreshOrderTable() {
        return _refreshOrderTable.apply(this, arguments);
      }

      return refreshOrderTable;
    }()
  }, {
    key: "isOrderDisabled",
    value: function isOrderDisabled(orderId) {
      var waypoints = this.getOrderField(orderId, 'waypoints');
      return this.helper.some(waypoints, function (waypoint) {
        return waypoint['completedTime'] !== '0000-00-00 00:00:00' && waypoint['completedTime'] !== null;
      });
    }
  }, {
    key: "getOrderId",
    value: function getOrderId(index) {
      return this.routeDetails['waypointId'][index].split('-')[0];
    }
  }, {
    key: "getWaypointEndTime",
    value: function getWaypointEndTime(index) {
      var _this6 = this;

      var waypoints = this.getOrderField(this.getOrderId(index), 'waypoints');

      if (this.helper.isUndefined(waypoints)) {
        return '';
      }

      var waypoint = waypoints.find(function (wp) {
        return wp.id === _this6.routeDetails['waypointId'];
      });

      if (this.helper.isUndefined(waypoint)) {
        return '';
      }

      return waypoint['endTime'];
    }
  }]);
  return LMDTruckSummaryModalComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDelivery.LastMileDeliveryMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDTruckSummaryModalComponent.prototype, "isVisible", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], LMDTruckSummaryModalComponent.prototype, "startTime", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: function _default() {}
})], LMDTruckSummaryModalComponent.prototype, "routeDetails", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: null
})], LMDTruckSummaryModalComponent.prototype, "routeIndex", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routeDetails')], LMDTruckSummaryModalComponent.prototype, "onDetailsChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isVisible', {
  immediate: true
})], LMDTruckSummaryModalComponent.prototype, "onVisibilityChanges", null);
LMDTruckSummaryModalComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDTruckSummaryModalComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-dialog': _elementUi.Dialog,
    'el-input-number': _elementUi.InputNumber,
    'el-time-picker': _elementUi.TimePicker,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-checkbox': _elementUi.Checkbox,
    'el-date-picker': _elementUi.DatePicker
  }
})], LMDTruckSummaryModalComponent);
var _default2 = LMDTruckSummaryModalComponent;
exports.default = _default2;